import { Drawer } from '@mui/material';
import React, { useCallback, useState } from 'react';
import CloseIcon from 'assets/png/close.svg';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { PositionFilterForm } from './PositionFilterForm';
import { ClientFilterSchema } from 'utils/ValidatorSchema';
import { ClientFilterType } from 'types';
import { useLocation } from 'react-router-dom';

interface ClientFilterDrawerProps {
  isOpen: boolean;
  closeDrawer: () => void;
  setParams: any;
  setcommonstate?: any;
  commonState?: any;
  setLoading?: any;
  isLoading?: any;
  setpagetotal?: any;
  listdataapi?: any;
  Defaultparam?: any;
}

export const PositionFilterDrawer: React.FC<ClientFilterDrawerProps> = ({
  isOpen,
  closeDrawer,
  setParams,
  Defaultparam,
}) => {
  const location: any = useLocation();
  const [key, setKey] = useState(0);
  const { control, handleSubmit, reset, formState, watch, trigger } = useForm<ClientFilterType>({
    criteriaMode: 'all',
    defaultValues: {
      from: undefined,
      to: undefined,
      status: undefined,
      crm: undefined,
      approvalStatus: undefined,
      location: undefined,
      industry: undefined,
    },
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(ClientFilterSchema),
  });

  const closeSideDrawer = useCallback(() => {
    closeDrawer();
  }, [closeDrawer]);

  const resetFilters = useCallback(() => {
    setParams((prev: any) => ({
      ...prev,
      from: null,
      to: null,
      location: null,
      status: null,
    }));
    reset();
    setKey((prev: number) => prev + 1);
    setParams(Defaultparam);
  }, [reset]);

  const onSubmit = (data: any) => {
    if (data.from || data.to || data.crm || data.approvalStatus || data.location || data.status) {
      if (!location.pathname.includes('approve')) {
        setParams((prev: any) => ({
          ...prev,
          from: data.from ? data.from : null,
          to: data.to ? data.to : null,
          location: data.location ? data.location : null,
          status: data.status,
          ...(data.approvalStatus ? { approvalStatus: data.approvalStatus } : null),
          ...(data.crm ? { crm: data.crm } : null),
        }));
      } else {
        setParams((prev: any) => ({
          ...prev,
          from: data.from ? data.from : null,
          to: data.to ? data.to : null,
          location: data.location ? data.location : null,
          status: data.status,
          ...(data.approvalStatus ? { approvalStatus: data.approvalStatus } : null),
          ...(data.crm ? { crm: data.crm } : null),
        }));
      }
    }
  };

  return (
    <Drawer
      anchor='right'
      open={isOpen}
      onClose={closeDrawer}
      sx={{
        flexShrink: 0,
        zIndex: 1200,
        ['& .MuiDrawer-paper']: {
          boxSizing: 'border-box',
          marginTop: '72px',
          width: '300px',
          padding: '30px',
          paddingTop: '0px',
        },
        ['& .MuiModal-backdrop ']: { backgroundColor: 'transparent' },
      }}>
      <header className='clientfilter-header'>
        <img
          src={CloseIcon}
          alt='closeicon'
          className='clientfilter-close-ico'
          onClick={closeSideDrawer}
        />
        <div className='heading'>Filters</div>
        <span
          className='clearall'
          style={{
            ...(!(
              watch('approvalStatus') ||
              watch('crm') ||
              watch('from') ||
              watch('industry') ||
              watch('location') ||
              watch('status') ||
              watch('to')
            )
              ? { opacity: '0.5', cursor: 'not-allowed' }
              : {}),
          }}
          onClick={() =>
            watch('approvalStatus') ||
            watch('crm') ||
            watch('from') ||
            watch('industry') ||
            watch('location') ||
            watch('status') ||
            watch('to')
              ? resetFilters()
              : ''
          }>
          Clear All
        </span>
      </header>
      <div className='clientfilter-divider'></div>
      <PositionFilterForm
        setParams={setParams}
        key={key}
        control={control}
        handleSubmit={handleSubmit}
        formState={formState}
        onSubmit={onSubmit}
        watch={watch}
        trigger={trigger}
      />
    </Drawer>
  );
};
